<template>
  <div>
    <Modal
      modalId="modalCamposPersonalizadosItemOportunidade"
      title="Campos personalizados do item"
      dialogClass="modal-lg"
      myClass="modal-campos-personalizados-item"
    >
      <template #body>
        <div v-if="!camposForm.length" class="alert alert-light border mb-0 text-center">
          Nenhum campo personalizado ativo configurado.
        </div>
        <div v-else class="row">
          <div
            v-for="campo in camposForm"
            :key="campo.id"
            class="col-12 col-md-6 mb-3"
          >
            <label class="small font-weight-bold d-block mb-1">{{ campo.nome }}</label>
            <select
              v-if="campo.tipo === TIPO_LISTA"
              v-model="campo.valor"
              class="form-control form-control-sm"
              :disabled="!podeEditar"
            >
              <option value="">—</option>
              <option v-for="opt in campo.opcoes" :key="opt" :value="opt">{{ opt }}</option>
            </select>
            <input
              v-else-if="campo.tipo === TIPO_DATA"
              v-model="campo.valor"
              type="text"
              class="form-control form-control-sm js-datepicker-campo-produto-item"
              placeholder="dd/mm/aaaa"
              :disabled="!podeEditar"
            />
            <input
              v-else-if="campo.tipo === TIPO_NUMERICO"
              v-model="campo.valor"
              type="text"
              class="form-control form-control-sm"
              placeholder="0,00"
              :disabled="!podeEditar"
            />
            <textarea
              v-else-if="campo.tipo === TIPO_TEXTO && campo.texto_area"
              v-model="campo.valor"
              class="form-control form-control-sm"
              rows="3"
              maxlength="250"
              :disabled="!podeEditar"
            />
            <input
              v-else
              v-model="campo.valor"
              type="text"
              class="form-control form-control-sm"
              maxlength="250"
              :disabled="!podeEditar"
            />
          </div>
        </div>
        <p v-if="!podeEditar" class="text-muted small mb-0 mt-2">
          Oportunidade não está aberta: visualização somente leitura.
        </p>
        <p v-if="formError" class="text-danger small mb-0 mt-2">{{ formError }}</p>
      </template>
      <template #footer>
        <button
          type="button"
          class="btn btn-depth btn-secondary btn-sm"
          @click="fechar"
        >
          Fechar
        </button>
        <button
          v-if="podeEditar"
          type="button"
          class="btn btn-depth btn-primary btn-sm ml-2"
          :disabled="salvando"
          @click="salvar"
        >
          {{ salvando ? 'Salvando…' : 'Salvar' }}
        </button>
      </template>
    </Modal>
  </div>
</template>

<script>
import api from '../../../api';
import Modal from '../ui/Modal.vue';

const TIPO_TEXTO = 1;
const TIPO_LISTA = 2;
const TIPO_NUMERICO = 3;
const TIPO_DATA = 4;

export default {
  name: 'ModalCamposPersonalizadosItemOportunidade',
  components: {
    Modal,
  },
  props: {
    definicoes: {
      type: Array,
      default: () => [],
    },
    urlSalvar: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      TIPO_TEXTO,
      TIPO_LISTA,
      TIPO_NUMERICO,
      TIPO_DATA,
      itemId: null,
      podeEditar: false,
      camposForm: [],
      salvando: false,
      formError: '',
    };
  },
  mounted() {
    $(document).on(
      'click',
      '.js-abrir-campos-personalizados-item',
      this.onClickAbrir
    );
  },
  beforeDestroy() {
    $(document).off(
      'click',
      '.js-abrir-campos-personalizados-item',
      this.onClickAbrir
    );
  },
  methods: {
    onClickAbrir(event) {
      const botao =
        event.target && typeof event.target.closest === 'function'
          ? event.target.closest('.js-abrir-campos-personalizados-item')
          : null;
      if (!botao) {
        return;
      }
      event.preventDefault();
      this.itemId = botao.getAttribute('data-item-id');
      this.podeEditar = botao.getAttribute('data-pode-editar') === '1';
      let valores = {};
      const rawValores = botao.getAttribute('data-valores') || '{}';
      try {
        valores = JSON.parse(rawValores);
      } catch (e) {
        try {
          const decoded = rawValores
            .replace(/&quot;/g, '"')
            .replace(/&#039;/g, "'")
            .replace(/&amp;/g, '&');
          valores = JSON.parse(decoded);
        } catch (e2) {
          valores = {};
        }
      }
      this.montarFormulario(valores);
      this.formError = '';
      $('#modalCamposPersonalizadosItemOportunidade').modal('show');
      this.$nextTick(() => {
        if (typeof window.initDatepicker === 'function') {
          window.initDatepicker($('.js-datepicker-campo-produto-item'));
        }
      });
    },
    montarFormulario(valores) {
      const lista = Array.isArray(this.definicoes) ? this.definicoes : [];
      this.camposForm = lista.map((def) => {
        const id = def.id;
        const raw = valores[id] ?? valores[String(id)] ?? '';
        let valor = raw === null || raw === undefined ? '' : String(raw);
        if (Number(def.tipo) === TIPO_NUMERICO && valor !== '') {
          const num = parseFloat(valor);
          if (!Number.isNaN(num)) {
            valor = num.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
          }
        }
        if (Number(def.tipo) === TIPO_DATA && valor !== '' && valor.indexOf('-') === 4) {
          const partes = valor.split('-');
          if (partes.length === 3) {
            valor = `${partes[2]}/${partes[1]}/${partes[0]}`;
          }
        }
        const opcoes = Array.isArray(def.conteudo)
          ? def.conteudo.filter((o) => o !== null && String(o).trim() !== '')
          : [];

        return {
          id,
          nome: def.nome,
          tipo: Number(def.tipo),
          texto_area: !!def.texto_area,
          opcoes,
          valor,
        };
      });
    },
    async salvar() {
      if (!this.podeEditar || !this.itemId) {
        return;
      }
      this.salvando = true;
      this.formError = '';
      const payload = {
        item_id: this.itemId,
        produto_campos: {},
      };
      this.camposForm.forEach((campo) => {
        payload.produto_campos[campo.id] = campo.valor;
      });
      try {
        const response = await api.put(this.urlSalvar, payload);
        if (response.data && response.data.error) {
          this.formError = response.data.message || 'Não foi possível salvar.';
          return;
        }
        const valores = response.data?.produto_campos || {};
        const botao = document.querySelector(
          '.js-abrir-campos-personalizados-item[data-item-id="' + this.itemId + '"]'
        );
        if (botao) {
          botao.setAttribute('data-valores', JSON.stringify(valores));
        }
        window.showToastSuccess('body', response.data?.message || 'Campos salvos.');
        this.fechar();
      } catch (error) {
        const msg =
          error.response?.data?.message ||
          'Não foi possível salvar os campos.';
        this.formError = msg;
        window.showToastDanger('body', msg);
      } finally {
        this.salvando = false;
      }
    },
    fechar() {
      const modal = document.getElementById('modalCamposPersonalizadosItemOportunidade');
      const ativo = document.activeElement;
      if (modal && ativo && modal.contains(ativo) && typeof ativo.blur === 'function') {
        ativo.blur();
      }
      $('#modalCamposPersonalizadosItemOportunidade').modal('hide');
    },
  },
};
</script>
